import { Mui } from "@osu/react-ui";
import Chip from "./scoresChip";
import styles from '../../dd-styles';

const BestTest = (props) => {
  const { studentData } = props;
  const score = studentData?.data?.bestTest?.score;
  const scoreLabel = (score == null || Number(score) === 0) ? "N/A" : score;

  return score !== "" ? (
    <>
      <Mui.Typography tabIndex="0" component="h3" variant="h6" >
        Best Test
      </Mui.Typography>
      <dl title="Best Test" style={styles.dl}>
        <dd tabIndex="0" style={styles.dd}>
          <Chip label={"Score"} childLabel={scoreLabel} />
        </dd>
      </dl>
      </>
  ) : (
    <></>
  );
};
export default BestTest;
